import { encryptPayload, decryptString } from './crypto';

export function initializeSecureStorage() {
  const originalSetItem = localStorage.setItem;
  const originalGetItem = localStorage.getItem;

  localStorage.setItem = function(key, value) {
    try {
      const stringValue = typeof value === 'string' ? value : String(value);
      const encrypted = encryptPayload(stringValue);
      originalSetItem.call(this, key, encrypted);
    } catch (e) {
      console.warn("Failed to encrypt local storage item", e);
      originalSetItem.call(this, key, value);
    }
  };

  localStorage.getItem = function(key) {
    const value = originalGetItem.call(this, key);
    if (!value) return value;
    
    try {
      if (value.includes(':')) {
        return decryptString(value);
      }
      return value;
    } catch (e) {
      return value;
    }
  };
}

initializeSecureStorage();
